export class RegistrationModel {
    Email !: any;
    Password !: any;
    MobileOrEmail !: any;
}